import { useMemo } from 'react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { usePlayerBaseInfoContext } from '@/scenarios/legacy-player/components/player-manager/context/PlayerBaseInfoProvider';
import { useProfileManager } from '@/shared/hooks/useProfileManager';

export function useDependencies() {
    const authManager = useAuthManager();
    const profileManager = useProfileManager();
    const { getPlayerBaseInfo } = usePlayerBaseInfoContext();

    return useMemo(
        () => ({
            authManager,
            profileManager,
            getPlayerBaseInfo,
        }),
        [authManager, profileManager, getPlayerBaseInfo]
    );
}

export type Dependencies = ReturnType<typeof useDependencies>;
